import type { Markings } from 'chessboard/plugins/markings/config/types';
import type { Game } from 'chessboard/model/game/types';
import { generatePrimaryKey } from 'chessboard/plugins/markings/service';
import { HighlightType } from 'chessboard/plugins/highlights/config/types';
import { toArray } from 'src/utils/array/to-array';

/**
 * Format a legacy marking for the markings API.
 */
export function formatForMarkingsAPI(
  legacyMarking: Game.Node.Api.Marking.Model,
  options: {
    node?: boolean;
    persistent?: boolean;
  } = {},
): Markings.KeyedModel[] {
  const [type, data] = Object.entries(legacyMarking)[0];
  const { node, persistent } = options;

  return toArray(data).map((rawMarking) => {
    const marking = {
      data: rawMarking,
      node,
      persistent,
      type: type === 'square' ? HighlightType : type, // "square" is legacy
    };

    return {
      ...marking,
      key: generatePrimaryKey(marking),
    };
  });
}
